import { Dropdown, Flag } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { switchLocale } from '../app/app-slice';

export default function LocaleSwitcher() {
  const dispatch = useDispatch();

  const supportedLocales = [
    { name: 'English', lang: 'en', country: 'us', locale: 'en-US' },
    { name: 'Deutsch', lang: 'de', country: 'de', locale: 'de-DE' },
    { name: 'Español', lang: 'es', country: 'mx', locale: 'es-ES' },
    { name: 'Español', lang: 'es', country: 'es', locale: 'es-ES' },
    { name: 'Française', lang: 'fr', country: 'ca', locale: 'fr-CA' },
    { name: 'Française', lang: 'fr', country: 'fr', locale: 'fr-FR' },
    { name: 'Italiano', lang: 'it', country: 'it', locale: 'it-IT' },
    { name: '日本語', lang: 'ja', country: 'jp', locale: 'ja-JP' },
    { name: 'Português', lang: 'pt', country: 'br', locale: 'pt-BR' },
    { name: 'Русский язык', lang: 'ru', country: 'ru', locale: 'ru-RU' },
    { name: '简体中文', lang: 'zh', country: 'cn', locale: 'zh-CN' },
  ];

  const currentLocale = useSelector((state) => state.app.locale) || 'en-US';
  const currentLocaleDescriptor = supportedLocales.find((supportedLocale) => supportedLocale.locale === currentLocale);

  function handleLocaleChangeRequest(e, { value }) {
    dispatch(switchLocale(value));
  }

  return (
    <div className="locale-switcher">
      <Flag name={currentLocaleDescriptor?.country} />
      <Dropdown text={currentLocaleDescriptor?.name}>
        <Dropdown.Menu>
          {supportedLocales.map((supportedLocale) => (
            <Dropdown.Item
              key={`${supportedLocale.locale}-${supportedLocale.country}`}
              flag={supportedLocale.country}
              value={supportedLocale.locale}
              text={supportedLocale.name}
              onClick={handleLocaleChangeRequest}
            />
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
